(function () {
    'use strict';

    var serviceId = 'yandexGeocode';

    angular.module('app.common')
        .factory(serviceId, ['$q', '$http', '$timeout', '$ocLazyLoad', '$rootScope', yandexGeocode]);

    function yandexGeocode($q, $http, $timeout, $ocLazyLoad, $rootScope) {
        var obj = {
            geocodeAddress: geocodeAddress
        };
        return obj;


        function ocLoadCheck(geocoDErest, deferred) {
            var counter = false;
            angular.element('script').filter(function (i, el) {
                var s = el.getAttribute('src');
                if (s && s.indexOf('maps.googleapis.com/maps') > -1) {
                    counter = true;
                }
            });
            if (!counter)
                $ocLazyLoad.load([
                    'js!https://maps.googleapis.com/maps/api/js?key=AIzaSyA1R2wFiWEsC5N0D_gHwm8l0qOMf4NWvgY&libraries=places&language=' + window.lang
                ]).then(function () {
                    googleBackUp(geocoDErest, deferred);

                });
            else {
                googleBackUp(geocoDErest, deferred);
            }
        }

        function googleBackUp(geocoDErest, deferred) {
            if (typeof google !== 'undefined') {
                var geocoder = new google.maps.Geocoder();
                geocoder.geocode(geocoDErest, function (results, status) {
                    if (status === google.maps.GeocoderStatus.OK) {
                        deferred.resolve(results[0].geometry.location);
                    }
                    else {
                        deferred.reject({
                            lat: function () { return null; },
                            lng: function () { return null; },
                            data: 'Konum Bulunamadi',
                            errorType: 2
                        });
                    }
                });
            }
            else {
                deferred.reject({
                    lat: function () { return null; },
                    lng: function () { return null; },
                    data: 'Konum Bulunamadi',
                    errorType: 2
                });
            }
        }

        function geocodeAddress(address, type, skip) {
            var deferred = $q.defer();

            if (address === null || address === undefined || address === '') {
                deferred.reject({
                    lat: function () { return null; },
                    lng: function () { return null; },
                    data: 'Konum Bulunamadi',
                    errorType: 2
                });
            }

            const langu = $rootScope.lang === 'tr' ? 'tr_TR' : $rootScope.lang === 'es-ES' ? 'es_ES' : $rootScope.lang === 'pt-PT' ? 'pt_PT' : 'en_US';
            // const countryId = ($rootScope.country === 'turkiye') ? 1 : ($rootScope.country === 'espana') ? 2 : ($rootScope.country === 'portugal') ? 3 : 0;
            // const langu = countryId === 1 ? 'tr_TR' : countryId === 2 ? 'es_ES' : countryId === 3 ? 'pt_PT' : 'en_US';

            var geocoDErest = {
                'address': address,

            };
            if ($rootScope.country === 'turkiye')
                geocoDErest.componentRestrictions = {
                    'country': 'TR'
                };
            else if ($rootScope.country === 'espana')
                geocoDErest.componentRestrictions = {
                    'country': 'ES'
                };
            else if ($rootScope.country === 'portugal')
                geocoDErest.componentRestrictions = {
                    'country': 'PT'
                };


            if (+type === 2 && $rootScope.country === 'turkiye')
                address = address + ' İlçesi';

            if (skip)
                $timeout(function () { deferred.resolve(null); }, 0);
            else {
                if ($rootScope.country !== 'turkiye')
                    ocLoadCheck(geocoDErest, deferred);
                else
                    $http({
                        dataType: 'json',
                        data: '',
                        method: 'GET',
                        url: 'https://geocode-maps.yandex.ru/1.x/?apikey=ea627200-e11e-49f5-b1b7-3c79067019c9&geocode=' + address + '&lang=' + langu + '&format=json'
                    }).then(
                        function (geocodeOk) {
                            if (+geocodeOk.status === 200) {
                                if (+geocodeOk.data.response.GeoObjectCollection.metaDataProperty.GeocoderResponseMetaData.found === 0) {
                                    ocLoadCheck(geocoDErest, deferred);
                                }
                                else {
                                    deferred.resolve({
                                        lat: function () {
                                            var lat = parseFloat(geocodeOk.data.response.GeoObjectCollection.featureMember["0"].GeoObject.Point.pos.split(" ")[1]);
                                            if (lat - 40.965544 === 0) {
                                                lat = lat - 0.061;
                                            }

                                            return lat;
                                        },
                                        lng: function () {
                                            var lng = parseFloat(geocodeOk.data.response.GeoObjectCollection.featureMember["0"].GeoObject.Point.pos.split(" ")[0]);
                                            if (lng - 29.106000 === 0) {
                                                lng = lng + 0.000290;
                                            }
                                            else if (lng - 29.052037 === 0) {
                                                lng = lng - 0.01;
                                            }
                                            return lng;
                                        },
                                        name: geocodeOk.data.response.GeoObjectCollection.featureMember["0"].GeoObject.name
                                    });
                                }
                            }
                            else {
                                ocLoadCheck(geocoDErest, deferred);
                            }

                        }, function () {
                            ocLoadCheck(geocoDErest, deferred);
                        });
            }

            return deferred.promise;
        }
    }
})();


